import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=712ec71c&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=712ec71c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ec71c",
  null
  
)

export default component.exports